/**
 * Kept separate from lazyWithChunkReload so tests can mock it: jsdom marks
 * `window.location.reload` non-configurable, so it cannot be stubbed in place.
 */
export function reloadPage(): void {
  window.location.reload();
}
